module.exports = "../images/cabin-4-person-4@2x.jpg?v=e7f545a";